import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {hideAppLoader, showAppLoader} from "app/Components/Shared/Loader/LoaderSlice";
import {
  createReportIdfNewPlanSignupApprovalInformationSecurity,
  createReportIdfNewPlanSignupApprovalTenderSummary, createReportIdfNewPlanSignupSelectedPackage
} from 'app/utilities/reports/createReport';

export const init = createAsyncThunk('IDFService/NewPlanSignupInit', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(setLoaded(false));
    thunkAPI.dispatch(showAppLoader());
    const result = await ProviderManager.getProviderData('NewPlanSignupInit', [data]);
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const execute = createAsyncThunk('IDFService/NewPlanSignup', async (data, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const state = thunkAPI.getState().idfNewPlanSignup;
    const authState = thunkAPI.getState().authentication?.loginData?.userDetails;
    const result = await ProviderManager.getProviderData('NewPlanSignup', {
      subscriberNo: authState.contactNumber,
      pricePlan: state.nextBpKey,
      socBlockId: state.selectedPackage.addonName,
      signupForm: {
        signatureData: {
          fullname: state.signupForm.fullName,
          id: state.signupForm.id,
          last4_pn_idf: state.signupForm.last4digits,
          sub_agreement: state.signupForm.optionalAds,
          move_data_by_law: state.signupForm.recipientUponDeath === 'allowedByLaw',
          move_data_to_person: state.signupForm.recipientUponDeath === 'someoneElse',
          dont_move_data: state.signupForm.recipientUponDeath === 'noOne',
          person_data_move: state.signupForm.recipientUponDeath === 'someoneElse' ? state.signupForm.recipientUponDeathName : '',
          accept_data_download: state.signupForm.agreeToRecipientChoice,
          accept_terms: state.signupForm.checkedPlanTermsAgreement,
          sign_name_terms: state.signupForm.planTermsAgreementFullName,
          i_have_signed_willingly: state.signupForm.checkedRecognizeForm,
          sign_name_willing: state.signupForm.recognizeFormFullName
        },
        acceptSecurity: state.checkedSecurityInfo,
        acceptAuction: state.checkedBidInfo,
      },
      mailForConfirmation: state.confirmationStep.email

    });
    thunkAPI.dispatch(hideAppLoader());
    return result.Body;
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return error;
  }
});

export const summaryReasons = {
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR'
}
export const steps = {
  SELECTION: 'SELECTION',
  AGREEMENTS: 'AGREEMENTS',
  CONFIRMATION: 'CONFIRMATION',
  SUMMARY: 'SUMMARY'
}

export const popUpTypes = {
  SIGNUP_FORM: 'SIGNUP_FORM',
  SERVICE_FORM: 'SERVICE_FORM'
}

const initialState = {
  currentPackage: null,
  selectedPackage: null,
  summaryReason: null,
  packages: null,
  currentStep: steps.SELECTION,
  checkedSecurityInfo: false,
  checkedBidInfo: false,
  currentPopUp: null,
  displayPopUp: false,
  signupForm: {
    fullName: '',
    id: '',
    last4digits: '',
    errors: {},
    optionalAds: false,
    recipientUponDeath: 'allowedByLaw',
    recipientUponDeathName: '',
    agreeToRecipientChoice: false,
    checkedPlanTermsAgreement: false,
    planTermsAgreementFullName: '',
    checkedRecognizeForm: false,
    recognizeFormFullName: '',
    errorText: null,
    signed: false
  },
  confirmationStep: {
    errors: {},
    email: ''
  },
  securityFormUrl: null,
  auctionFormUrl: null,
  loaded: false,
  nextBpKey: false
};



const idfNewPlanSignupSlice = createSlice({
  name: 'idfNewPlanSignup',
  initialState: initialState,
  reducers: {
    resetState: (state) => initialState,
    setSelectedPackage: (state, action) => {
      state.selectedPackage = state.packages.find(p => p.packageObj.contentLink.id === action.payload.blockID);
    },
    setStep: (state, action) => {
      state.currentStep = action.payload;
      return state;
    },
    checkSecurityInfo: (state, action) => {
      state.checkedSecurityInfo = true;
      return state;
    },
    checkBidInfo: (state, action) => {
      state.checkedBidInfo = true;
      return state;
    },
    unCheckSecurityInfo: (state) => {
      state.checkedSecurityInfo = false;
      return state;
    },
    unCheckBidInfo: (state) => {
      state.checkedBidInfo = false;
      return state;
    },
    closePopUp: (state) => {
      state.displayPopUp = false;
      return state;
    },
    openPopUp: (state, action) => {
      state.displayPopUp = true;
      return state;
    },
    setPopUp: (state, action) => {
      state.currentPopUp = action.payload;
      return state;
    },
    updateFormValue: (state, action) => {
      state[action.payload.formName][action.payload.fieldName] = action.payload.value;
      return state;
    },
    setFieldError: (state, action) => {
      state[action.payload.formName].errors[action.payload.fieldName] = action.payload.value;
      return state;
    },
    checkPlanTermsAgreement: (state, action) => {
      state.signupForm.checkedPlanTermsAgreement = action.payload;
      return state;
    },
    toggleAds: (state) => {
      state.signupForm.optionalAds = !state.signupForm.optionalAds;
      return state;
    },
    checkSignupRadio: (state, action) => {
      state.signupForm.recipientUponDeath = action.payload.value;
      return state;
    },
    toggleAgreeToRecipientChoice: (state) => {
      state.signupForm.agreeToRecipientChoice = !state.signupForm.agreeToRecipientChoice;
      //get the errors object, and filter the correct key
      state.signupForm.errors = Object.fromEntries(
        Object.entries(state.signupForm.errors)
          .filter(([key]) => key !== 'agreeToRecipientChoice'));
      return state;
    },
    togglePlanTermsAgreement: (state) => {
      state.signupForm.checkedPlanTermsAgreement = !state.signupForm.checkedPlanTermsAgreement;
      //reset error and remove field from errors
      state.signupForm.errors = Object.fromEntries(
        Object.entries(state.signupForm.errors)
          .filter(([key]) => key !== 'checkedPlanTermsAgreement'));
      return state;
    },
    toggleRecognizeForm: (state) => {
      state.signupForm.checkedRecognizeForm = !state.signupForm.checkedRecognizeForm;
      //reset error
      state.signupForm.errors = Object.fromEntries(
        Object.entries(state.signupForm.errors)
          .filter(([key]) => key !== 'checkedRecognizeForm'));
      return state;
    },
    setErrorText: (state, action) => {
      state[action.payload.formName].errorText = action.payload.value;
      return state;
    },
    resetFormErrors: (state, action) => {
      state[action.payload.formName].errors = {};
      return state;
    },
    signForm: (state, action) => {
      state.signupForm.signed = true;
      return state;
    },
    setLoaded: (state, action) => {
      state.loaded = action.payload;
      return state;
    },
    saveToHistory: (state, action) => {
      return state;
    },
    clearHistory: (state, action) => {
      return state;
    },
    fillSignUpFormFields: (state, action) => {
      state.signupForm.fullName = action.payload.fullName;
      state.signupForm.id = action.payload.id;
      state.signupForm.last4digits = action.payload.last4digits;
      return state;
    }
  },
  extraReducers: {
    [init.fulfilled]: (state, action) => {
      //check for success and error
      if (action.payload.isSuccess) {
        state.packages = action.payload.extra.packagesToDisplay;
        state.currentPackage = action.payload.extra.currentPackage;
        state.securityFormUrl = action.payload.extra.forms.securityForm;
        state.auctionFormUrl = action.payload.extra.forms.auctionForm;
        state.nextBpKey = action.payload.extra.bPkey;
      } else {
        state.summaryReason = summaryReasons.ERROR;
        state.currentStep = steps.SUMMARY;
      }
      state.loaded = true;
      return state;
    },
    [execute.fulfilled]: (state, action) => {
      state.currentStep = steps.SUMMARY;
      state.summaryReason = action.payload.isSuccess ? summaryReasons.SUCCESS : summaryReasons.ERROR;
      return state;
    }
  }
});

export const {
  resetState,
  setSelectedPackage,
  setStep,
  checkSecurityInfo,
  checkBidInfo,
  unCheckSecurityInfo,
  unCheckBidInfo,
  openPopUp,
  closePopUp,
  setPopUp,
  updateFormValue,
  setFieldError,
  toggleAds,
  checkSignupRadio,
  toggleAgreeToRecipientChoice,
  togglePlanTermsAgreement,
  toggleRecognizeForm,
  setErrorText,
  resetFormErrors,
  signForm,
  setLoaded,
  saveToHistory,
  clearHistory,
  fillSignUpFormFields
} = idfNewPlanSignupSlice.actions;

export default idfNewPlanSignupSlice.reducer;
